
import {createAsyncThunk, createSlice, current} from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
const initialState = {
    currentMenuKey:sessionStorage.getItem('currentMenuKey')?sessionStorage.getItem('currentMenuKey'):Cookies.get('type')==2?"6":"1",
};

export const homePageSlice = createSlice({
    name: 'modals',
    initialState,
    reducers: {
        setCurrentMenuKey: (state,action) => {
            sessionStorage.setItem('currentMenuKey',action.payload);
            state.currentMenuKey = action.payload;
        }
    },
});

export const selectCurrentMenuKey = (state) => state.homePage.currentMenuKey;
export const {
    setCurrentMenuKey
} = homePageSlice.actions;

export default homePageSlice.reducer;
